module.exports = __webpack_public_path__ + "static/media/gallerryimg6.40a44e6d.JPG";